import React from 'react';
import TabelaCrud from '../components/TabelaCrud';
import { getCurrentTenantId } from '../services/api';
import { useCreches } from '../hooks/useCreches';

interface Vacina { id: number; creche_id: number; aluno_id: number; vacina: string; dose: string; data_aplicacao: string; proxima_dose: string; lote: string; }
interface Alergia { id: number; creche_id: number; aluno_id: number; tipo: string; descricao: string; gravidade: string; conduta: string; }
interface Medicamento { id: number; creche_id: number; aluno_id: number; medicamento: string; dosagem: string; horarios: string; autorizado_por: string; validade_autorizacao: string; }
interface FichaSaude { id: number; creche_id: number; aluno_id: number; tipo_sanguineo: string; convenio: string; pediatra: string; pediatra_contato: string; restricoes_alimentares: string; observacoes: string; }

export default function SaudePage() {
  const { options } = useCreches();
  const tenantScoped = Boolean(getCurrentTenantId());

  const seletorCreche = (i: { creche_id?: number }, onChange: (campo: any, valor: any) => void) => (
    <label className={tenantScoped ? 'campo-tenant-oculto' : undefined}>Creche
      <select value={i.creche_id ?? 0} onChange={(e) => onChange('creche_id', Number(e.target.value))}>
        <option value={0}>Selecione...</option>
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
  );

  return (
    <div className="stack-cadastros">
      <TabelaCrud<Vacina>
        titulo="Saúde — Carteira de Vacinas"
        endpoint="/saude/vacinas"
        colunas={[
          { chave: 'id', label: 'ID' },
          { chave: 'aluno_id', label: 'Criança ID' },
          { chave: 'vacina', label: 'Vacina' },
          { chave: 'dose', label: 'Dose' },
          { chave: 'data_aplicacao', label: 'Aplicação' },
          { chave: 'proxima_dose', label: 'Próxima dose' },
        ]}
        itemVazio={{ creche_id: 0, aluno_id: 0, vacina: '', dose: '', data_aplicacao: '', proxima_dose: '', lote: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.aluno_id || !i.vacina || !i.data_aplicacao ? 'Preencha criança, vacina e data de aplicação.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              {seletorCreche(i, onChange)}
              <label>Criança ID<input type="number" value={i.aluno_id ?? 0} onChange={(e) => onChange('aluno_id', Number(e.target.value))} /></label>
            </div>
            <div className="linha-campos linha-2">
              <label>Vacina<input value={i.vacina ?? ''} onChange={(e) => onChange('vacina', e.target.value)} /></label>
              <label>Dose<input value={i.dose ?? ''} onChange={(e) => onChange('dose', e.target.value)} placeholder="ex.: 1ª dose, reforço" /></label>
            </div>
            <div className="linha-campos linha-3">
              <label>Data de aplicação<input type="date" value={i.data_aplicacao ?? ''} onChange={(e) => onChange('data_aplicacao', e.target.value)} /></label>
              <label>Próxima dose<input type="date" value={i.proxima_dose ?? ''} onChange={(e) => onChange('proxima_dose', e.target.value)} /></label>
              <label>Lote<input value={i.lote ?? ''} onChange={(e) => onChange('lote', e.target.value)} /></label>
            </div>
          </>
        )}
      />

      <TabelaCrud<Alergia>
        titulo="Saúde — Alergias e Restrições"
        endpoint="/saude/alergias"
        colunas={[
          { chave: 'id', label: 'ID' },
          { chave: 'aluno_id', label: 'Criança ID' },
          { chave: 'tipo', label: 'Tipo' },
          { chave: 'gravidade', label: 'Gravidade' },
        ]}
        itemVazio={{ creche_id: 0, aluno_id: 0, tipo: 'alimentar', descricao: '', gravidade: 'leve', conduta: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.aluno_id || !i.descricao ? 'Preencha criança e a descrição da alergia.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              {seletorCreche(i, onChange)}
              <label>Criança ID<input type="number" value={i.aluno_id ?? 0} onChange={(e) => onChange('aluno_id', Number(e.target.value))} /></label>
            </div>
            <div className="linha-campos linha-2">
              <label>Tipo<select value={i.tipo ?? 'alimentar'} onChange={(e) => onChange('tipo', e.target.value)}><option value="alimentar">Alimentar</option><option value="medicamentosa">Medicamentosa</option><option value="respiratoria">Respiratória</option><option value="outra">Outra</option></select></label>
              <label>Gravidade<select value={i.gravidade ?? 'leve'} onChange={(e) => onChange('gravidade', e.target.value)}><option value="leve">Leve</option><option value="moderada">Moderada</option><option value="grave">Grave</option></select></label>
            </div>
            <label>Descrição<textarea rows={2} value={i.descricao ?? ''} onChange={(e) => onChange('descricao', e.target.value)} /></label>
            <label>Conduta em caso de reação<textarea rows={2} value={i.conduta ?? ''} onChange={(e) => onChange('conduta', e.target.value)} placeholder="O que a equipe deve fazer" /></label>
          </>
        )}
      />

      <TabelaCrud<Medicamento>
        titulo="Saúde — Medicamentos Autorizados"
        endpoint="/saude/medicamentos"
        colunas={[
          { chave: 'id', label: 'ID' },
          { chave: 'aluno_id', label: 'Criança ID' },
          { chave: 'medicamento', label: 'Medicamento' },
          { chave: 'dosagem', label: 'Dosagem' },
          { chave: 'validade_autorizacao', label: 'Validade' },
        ]}
        itemVazio={{ creche_id: 0, aluno_id: 0, medicamento: '', dosagem: '', horarios: '', autorizado_por: '', validade_autorizacao: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.aluno_id || !i.medicamento || !i.dosagem || !i.autorizado_por ? 'Preencha criança, medicamento, dosagem e quem autorizou.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              {seletorCreche(i, onChange)}
              <label>Criança ID<input type="number" value={i.aluno_id ?? 0} onChange={(e) => onChange('aluno_id', Number(e.target.value))} /></label>
            </div>
            <div className="linha-campos linha-2">
              <label>Medicamento<input value={i.medicamento ?? ''} onChange={(e) => onChange('medicamento', e.target.value)} /></label>
              <label>Dosagem<input value={i.dosagem ?? ''} onChange={(e) => onChange('dosagem', e.target.value)} placeholder="ex.: 5ml, 1 comprimido" /></label>
            </div>
            <div className="linha-campos linha-3">
              <label>Horários<input value={i.horarios ?? ''} onChange={(e) => onChange('horarios', e.target.value)} placeholder="ex.: 8h e 14h" /></label>
              <label>Autorizado por<input value={i.autorizado_por ?? ''} onChange={(e) => onChange('autorizado_por', e.target.value)} placeholder="Responsável / médico" /></label>
              <label>Validade da autorização<input type="date" value={i.validade_autorizacao ?? ''} onChange={(e) => onChange('validade_autorizacao', e.target.value)} /></label>
            </div>
          </>
        )}
      />

      <TabelaCrud<FichaSaude>
        titulo="Saúde — Ficha e Condições"
        endpoint="/saude/ficha"
        colunas={[
          { chave: 'id', label: 'ID' },
          { chave: 'aluno_id', label: 'Criança ID' },
          { chave: 'tipo_sanguineo', label: 'Tipo sanguíneo' },
          { chave: 'convenio', label: 'Convênio' },
          { chave: 'pediatra', label: 'Pediatra' },
        ]}
        itemVazio={{ creche_id: 0, aluno_id: 0, tipo_sanguineo: '', convenio: '', pediatra: '', pediatra_contato: '', restricoes_alimentares: '', observacoes: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.aluno_id ? 'Selecione a criança.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              {seletorCreche(i, onChange)}
              <label>Criança ID<input type="number" value={i.aluno_id ?? 0} onChange={(e) => onChange('aluno_id', Number(e.target.value))} /></label>
            </div>
            <div className="linha-campos linha-3">
              <label>Tipo sanguíneo<input value={i.tipo_sanguineo ?? ''} onChange={(e) => onChange('tipo_sanguineo', e.target.value)} placeholder="ex.: O+" /></label>
              <label>Convênio / plano<input value={i.convenio ?? ''} onChange={(e) => onChange('convenio', e.target.value)} /></label>
              <label>Pediatra<input value={i.pediatra ?? ''} onChange={(e) => onChange('pediatra', e.target.value)} /></label>
            </div>
            <label>Contato do pediatra<input value={i.pediatra_contato ?? ''} onChange={(e) => onChange('pediatra_contato', e.target.value)} /></label>
            <label>Restrições alimentares<textarea rows={2} value={i.restricoes_alimentares ?? ''} onChange={(e) => onChange('restricoes_alimentares', e.target.value)} /></label>
            <label>Observações de saúde<textarea rows={2} value={i.observacoes ?? ''} onChange={(e) => onChange('observacoes', e.target.value)} /></label>
          </>
        )}
      />
    </div>
  );
}
